import * as types from '../../types'
import Immutable from 'immutable'
import diff from 'immutablediff'
import patch from 'immutablepatch'

const INITIAL_STATE = Immutable.fromJS({
    saving: false,
    filter: '',
    modalCreate: {
        show: false,
        data: null,
        roles: []
    }
})

export default function (state = INITIAL_STATE, action) {
    let temp
    switch (action.type) {
        case types.PLANTILLAS_REINICIAR_ESTADO:
            return INITIAL_STATE
        case types.PLANTILLAS_GUARDANDO:
            state = state.set('saving', action.payload)
            return state
        case types.PLANTILLAS_MOSTRAR_OCULTAR_MODAL_CREATE:
            state = state.setIn(['modalCreate', 'show'], action.payload.show)
            if (action.payload.show) {
                state = state.setIn(['modalCreate', 'data'], Immutable.fromJS(action.payload.item))
            } else {
                state = state.set('modalCreate', INITIAL_STATE.get('modalCreate'))
            }
            return state
        case types.PLANTILLAS_ACTUALIZAR_REGISTROS:
            temp = diff(state.getIn(`plantillas.data.${action.payload.id}`.split('.')), Immutable.fromJS(action.payload.item))
            state = state.setIn(`plantillas.data.${action.payload.id}`.split('.'), patch(state.getIn(`plantillas.data.${action.payload.id}`.split('.')), temp))
            return state
        default:
            return state
    }
}